import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LanguageSelect from 'components/LanguageSelect';
import { handleLexiconRulesExport } from 'libs/download-csv';
import PrimaryAddButton from 'components/PrimaryAddButton';
import DownloadButton from 'components/DownloadButton';
import { txt } from 'libs/i18n';
import { useSession } from 'components/Authenticated';
import * as UserlexAPI from 'api/userlex-api';
import styles from './style.module.less';
const UserlexToolbar = ({ onAdd, userlex, setUserlex }) => {
    const { session } = useSession();
    return (_jsxs("div", { className: styles.toolbar, children: [_jsx(PrimaryAddButton, { label: txt('addWord'), onClick: onAdd }), _jsxs("div", { className: styles.toolbarRight, children: [_jsx("span", { className: styles.inputLabel, children: `${txt('lexiconLanguage')}:` }), _jsx(LanguageSelect, { className: styles.languageSelect, locales: userlex.locales, value: userlex.selectedLang, onChange: async (newLanguage) => {
                            const result = await UserlexAPI.fetchCurrentUserlex(session.connection, newLanguage);
                            if (result.isSuccess()) {
                                setUserlex(Object.assign(Object.assign({}, userlex), { entries: result.get(), selectedLang: newLanguage }));
                            }
                        } }), _jsx(DownloadButton, { className: styles.downloadButton, onDownload: async () => handleLexiconRulesExport(session.connection, userlex.selectedLang.code), title: txt('downloadInCSV') })] })] }));
};
export default UserlexToolbar;
